<div class="p-selectbutton p-buttonset p-component" [class.p-disabled]="disabled" role="group" [attr.aria-disabled]="disabled">
  @for (opt of options; track opt) {
    <button
      type="button"
      class="p-element p-button p-component"
      [class.p-highlight]="isSelected(opt)"
      [disabled]="isOptionDisabled(opt)"
      [attr.aria-pressed]="isSelected(opt)"
      (click)="onOptionClick($event, opt)"
      >
      @if (itemTemplate) {
        <ng-container
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ $implicit: opt, item: opt }"
        ></ng-container>
      } @else {
        <span class="p-button-label select-button-label">{{ getOptionLabel(opt) }}</span>
      }
    </button>
  }
</div>

